/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiaryDto } from '../../models/diary-dto';

export interface DiaryControllerFindOneV1$Params {
  id: string;
}

export function diaryControllerFindOneV1(http: HttpClient, rootUrl: string, params: DiaryControllerFindOneV1$Params, context?: HttpContext): Observable<StrictHttpResponse<DiaryDto>> {
  const rb = new RequestBuilder(rootUrl, diaryControllerFindOneV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiaryDto>;
    })
  );
}

diaryControllerFindOneV1.PATH = '/api/v1/diary/{id}';
